enum TradeStatus {
  DEVIATION_REQUESTED = "Deviation Requested",
  DEVIATION_APPROVED = "Final Approval",
  DEVIATION_REJECTED = "Deviation Rejected",
  DEVIATION_RECOMMENDATION = "Recommendation",
  OVERDUE_REQUESTED = "Overdue Approval Requested",
  OVERDUE_REJECTED = "Overdue Approval Rejected",
  OVERDUE_APPROVED = "Overdue Approval Accepted",
  OVERDUE_RECOMMENDED = "Overdue Approval Recommendation",
  OVERDUE_FINAL_APPROVAL = "Overdue Approval Final Approval",
}

export default TradeStatus
